/*
 * @Author: lixin jiang
 * @Date: 2021-09-27 10:26:37
 * @LastEditTime: 2021-09-27 15:16:43
 * @LastEditors: lixin jiang
 * @Description:
 * @FilePath: /aid-base/src/components/Modal/index.js
 * @
 */
import Modal from './modal';

export default Modal;
